import addAriaLiveLabel from '../actions/addAriaLiveLabel';
import addAriaLiveLabelHelper from '../actions/addAriaLiveLabelHelper';
import removeAriaLiveLabel from '../actions/removeAriaLiveLabel';
import { AriaLiveLevel } from '../store/schema/AccessibilityStore';
import { orchestrator } from 'satcheljs';

const ARIA_LIVE_TIMEOUT_IN_MILLISECONDS: number = 10000;

/**
 * If we have triggered this orchestrator, this means we are in the process of adding an arialive label
 * This will hence add the new AriaLiveLabel and make it tabbable, which can give a bad experience for accessibility users
 * We can try set aria-hidden for the AriaLiveWrapper but that will remove it from the list of screen reader observables which is unintended
 * Hence we will trigger a removal of the ariaLiveLabel after a timeout using removeAriaLiveLabel in setTimeout
 * We keep a timeout of 10 seconds for now.
 */
export default orchestrator(
    addAriaLiveLabel,
    (actionMessage: { ariaLiveLabel: string; ariaLiveLevel: AriaLiveLevel }) => {
        const { ariaLiveLabel, ariaLiveLevel } = actionMessage;

        // First add the label
        addAriaLiveLabelHelper(ariaLiveLabel, ariaLiveLevel);

        // Now try removing the added label after a timeout
        setTimeout(() => {
            // Attempt to remove the aria-live label ARIA_LIVE_TIMEOUT_IN_MILLISECONDS units after it is added in the dom tree
            removeAriaLiveLabel(actionMessage.ariaLiveLabel);
        }, ARIA_LIVE_TIMEOUT_IN_MILLISECONDS);
    }
);
